import type { LaborLineEdits, LaborRowItem } from "../types";
import type { SupplierComparisonCartItem } from "./buildSupplierComparisonValues";

export function buildLaborSupplierComparisonValues(
    laborRows: LaborRowItem[],
    labor: LaborLineEdits = {},
    cartIds: Record<string, string> = {},
): Record<string, SupplierComparisonCartItem> {
    const result: Record<string, SupplierComparisonCartItem> = {};

    for (const row of laborRows) {
        const edit = labor[row.id];
        const cartId = cartIds[row.id];
        if (!edit?.laborServiceId || !cartId || Number(edit.quantity) <= 0) {
            continue;
        }

        result[row.id] = {
            id: cartId,
            manufacturerProductId: edit.laborServiceId,
            value: row.name,
            supplierName: edit.supplierName || undefined,
        };
    }

    return result;
}
